import { call, put } from 'redux-saga/effects'
import { baseFetchToken } from './BaseSaga'
import EventsActions from '../Redux/EventsRedux'
import AuthActions from '../Redux/AuthRedux'
import { getToken } from '../Services/GetToken'

export function * getAllEvents (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getAllEvents, token, action.data)
      if (!res.ok) {
        yield put(EventsActions.getAllEventsFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const paginatedData = {
            data: res.data.data,
            page,
            total
          }
          yield put(EventsActions.getAllEventsSuccess(paginatedData))
        } else {
          yield put(EventsActions.getAllEventsFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(EventsActions.getAllEventsFailure())
  }
}

export function * getAllPopularEvents (api, action) {
  yield baseFetchToken(
    api.getAllPopularEvents,
    action.data,
    getToken,
    EventsActions.getAllPopularEventsSuccess,
    EventsActions.getAllPopularEventsFailure
  )
}

export function * getEventsCategories (api, action) {
  yield baseFetchToken(
    api.getEventsCategories,
    action.data,
    getToken,
    EventsActions.getEventsCategoriesSuccess,
    EventsActions.getEventsCategoriesFailure
  )
}

export function * setPopularEvent (api, action) {
  yield baseFetchToken(
    api.setPopularEvent,
    action.data,
    getToken,
    EventsActions.setPopularEventSuccess,
    EventsActions.setPopularEventFailure
  )
}

export function * resetEventDescription (api, action) {
  yield baseFetchToken(
    api.resetEventDescription,
    action.data,
    getToken,
    EventsActions.resetEventDescriptionSuccess,
    EventsActions.resetEventDescriptionFailure
  )
}

export function * updateEventDescription (api, action) {
  yield baseFetchToken(
    api.updateEventDescription,
    action.data,
    getToken,
    EventsActions.updateEventDescriptionSuccess,
    EventsActions.updateEventDescriptionFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/EventsSagas.js